/**
 * 액션 디스패처
 * 액션을 받아서 적절한 핸들러를 실행
 */
export class ActionDispatcher {
    constructor() {
        this.handlers = new Map();
    }
    /**
     * 액션 핸들러 등록
     */
    register(type, handler) {
        this.handlers.set(type, handler);
    }
    /**
     * 여러 핸들러 일괄 등록
     */
    registerMany(handlers) {
        for (const [type, handler] of Object.entries(handlers)) {
            this.handlers.set(type, handler);
        }
    }
    /**
     * 액션 디스패치
     * @returns 새 상태 또는 null (변경 없음)
     */
    dispatch(state, action) {
        const handler = this.handlers.get(action.type);
        if (!handler) {
            return {
                newState: null,
                error: `Unknown action type: ${action.type}`
            };
        }
        try {
            const newState = handler(state, action);
            return { newState };
        }
        catch (error) {
            return {
                newState: null,
                error: error instanceof Error ? error.message : String(error)
            };
        }
    }
    /**
     * 등록된 액션 타입 목록
     */
    getRegisteredTypes() {
        return Array.from(this.handlers.keys());
    }
    /**
     * 핸들러 존재 여부 확인
     */
    hasHandler(type) {
        return this.handlers.has(type);
    }
}
//# sourceMappingURL=dispatcher.js.map